import React from "react";
import { useMediaQuery, useTheme } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import moment from "moment";
import OptionsButtonCustom from "../../../../components/option-button/OptionsButtonCustom";
import TableRowCommon from "../../../../components/table/TableRowCommon";
import {
  alertActive,
  alertError,
  alertSuccess,
} from "../../../../components/alert/swal";
import {
  setLoading,
  unsetLoading,
} from "../../../../store/loading/loading.slice";
import ContainerLayout from "../../../../components/container-layout/ContainerLayout";
import StateComponents from "../../../../components/state-component/StateComponents";
import { debouncedApiCall } from "../../../../utils/app.utils";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { ButtonPrimary } from "../../../../components/button/ButtonCustoms";
import TableCustom from "../../../../components/table/tableCustom";
import ModalCustom from "../../../../components/modal/ModalCustom";
import NavigateListCustom from "../../../../components/navigation/NavigationListCustom";
import { routeName } from "../../../../routes/routeName";
import AutocompleteSelect from "../../../../components/select/autoCompleteSelect";
import { EmployeeApi } from "../../../../api/employee/employee.api";
import UploadAvatar from "../../../../components/upload/UploadAvatar";
import { edpexMissionAPI } from "../../../../api/edpex-mission/edpex-mission.api";
import SwitchCustom from "../../../../components/switch/SwitchCustom";

const EdpexMission = () => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("md"));
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  const [showModal, setShowModal] = useState<string>("");
  const [page, setPage] = useState<number>(1);
  const [pageLimit, setPageLimit] = useState<number>(10);
  const [totalItems, setTotalItems] = useState<number>(13);
  const [sortBy, setSortBy] = useState<string>("modified_date");
  const [sortType, setSortType] = useState<string>("DESC");
  const [search, setSearch] = useState<string>("");
  const [id_item, set_id_item] = useState<number | null>(null);
  const [data, setData] = useState<any[]>([]);

  const [formState, setFormState] = useState<{
    edpex_mission_name: string;
    edpex_mission_desc: string;
  }>({
    edpex_mission_name: "",
    edpex_mission_desc: "",
  });

  const handleCloseModal = () => {
    setShowModal("");
    setFormState({
      edpex_mission_name: "",
      edpex_mission_desc: "",
    });
    set_id_item(null);
  };
  const handleShowModal = (mode: string) => {
    setShowModal(mode);
  };
  const handleRequestSort = (sortBy: string, sortType: string) => {
    setSortBy(sortBy);
    setSortType(sortType);
  };

  const headCells = [
    {
      id: "ชื่อพันธกิจ", // i18n-ignore (column id)
      width: 100,
      sortable: true,
      disablePadding: false,
      align: "center",
      label: t("ชื่อพันธกิจ"),
    },
    {
      id: "สถานะ", // i18n-ignore (column id)
      disablePadding: false,
      align: "center",
      width: 300,
      label: t("สถานะ"),
    },
    {
      id: "ผู้ปรับปรุงล่าสุด", // i18n-ignore (column id)
      disablePadding: false,
      align: "center",
      width: 100,
      label: t("ผู้ปรับปรุงล่าสุด"),
    },
    {
      id: "วันที่ปรับปรุงล่าสุด", // i18n-ignore (column id)
      disablePadding: false,
      align: "center",
      width: 100,
      label: t("วันที่ปรับปรุงล่าสุด"),
    },
    {
      id: "s",
      disablePadding: false,
      align: "center",
      width: 100,
      class: matches,
      label: "",
    },
  ];

  const handleToggleStatus = async (id: number, st: boolean) => {
    const body = {
      status: st ? "active" : "inactive",
    };
    dispatch(setLoading());
    await edpexMissionAPI
      .updateEdpexMission(id, body)
      .then((res) => {
        if (res.status < 300) {
          handleGetData();
        }
      })
      .catch((err) => {
        console.log(err);
        alertError(t("แก้ไขสถานะพันธกิจ สำเร็จ"));
      })
      .finally(() => {
        dispatch(unsetLoading());
      });
  };

  const renderData = (objData: any, no: any) => {
    no = page * pageLimit - pageLimit + no + 1;
    const {
      id_edpex_mission,
      edpex_mission_name,
      edpex_mission_desc,
      status,
      modifier_name,
      modified_date,
    } = objData;

    const objRenderData = {
      key: no,
      id: no,
      obj: objData,
      columns: [
        {
          option: "TEXT",
          align: "left",
          label: edpex_mission_name || "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: (
            <span className="flex justify-center items-center">
              <SwitchCustom
                checked={status === "active" ? true : false}
                onChange={(status_data) =>
                  handleToggleStatus(id_edpex_mission, status_data)
                }
              />
            </span>
          ),
        },
        {
          option: "TEXT",
          align: "center",
          label: modifier_name || "-",
        },
        {
          option: "TEXT",
          align: "center",
          label:
            moment(modified_date || new Date())
              .add(i18n.language === "en" ? 0 : 543, "year")
              .format("l") ||
            modified_date ||
            "-",
        },
        {
          option: "COMPONENT",
          align: "center",
          class: matches,
          width: 300,
          component: (
            <OptionsButtonCustom
              enableView
              enableEdit
              enableDelete
              onDeleteClick={() => handleDelete(id_edpex_mission)}
              onViewClick={() => {
                handleShowModal("VIEW");
                set_id_item(id_edpex_mission);
                setFormState({
                  edpex_mission_name: edpex_mission_name,
                  edpex_mission_desc: edpex_mission_desc,
                });
              }}
              onEditClick={() => {
                handleShowModal("EDIT");
                set_id_item(id_edpex_mission);
                setFormState({
                  edpex_mission_name: edpex_mission_name,
                  edpex_mission_desc: edpex_mission_desc,
                });
              }}
            />
          ),
        },
      ],
    };
    return <TableRowCommon {...objRenderData} />;
  };

  const handleDelete = (id_item: number) => {
    alertActive(
      t("ลบพันธกิจ"),
      t("ต้องการลบพันธกิจ"),
      undefined,
      undefined,
      async () => {
        dispatch(setLoading());
        await edpexMissionAPI
          .deleteEdpexMission(id_item)
          .then((res) => {
            if (res.status < 300) {
              alertSuccess(t("ลบพันธกิจ"), t("ลบพันธกิจ สำเร็จ"));
              handleGetData();
            }
          })
          .catch((err) => {
            alertError(t("ลบพันธกิจ"), t("ลบพันธกิจ ไม่สำเร็จ"));
            console.log(err);
          })
          .finally(() => {
            dispatch(unsetLoading());
          });
      }
    );
  };

  const handleSubmit = async () => {
    const body: any = {
      edpex_mission_name: formState.edpex_mission_name,
      edpex_mission_desc: formState.edpex_mission_desc,
    };
    dispatch(setLoading());
    if (id_item) {
      await edpexMissionAPI
        .updateEdpexMission(id_item, body)
        .then((res) => {
          if (res.status < 300) {
            alertSuccess(t("แก้ไขพันธกิจ"), t("แก้ไขพันธกิจ สำเร็จ"));
            handleGetData();
            handleCloseModal();
          }
        })
        .catch((err) => {
          console.log(err);
          alertError(t("แก้ไขพันธกิจ"), t("แก้ไขพันธกิจ ไม่สำเร็จ"));
        })
        .finally(() => {
          dispatch(unsetLoading());
        });
    } else {
      await edpexMissionAPI
        .createEdpexMission(body)
        .then((res) => {
          if (res.status < 300) {
            alertSuccess(t("เพิ่มพันธกิจ"), t("เพิ่มพันธกิจ สำเร็จ"));
            handleGetData();
            handleCloseModal();
          }
        })
        .catch((err) => {
          console.log(err);
          alertError(t("เพิ่มพันธกิจ"), t("เพิ่มพันธกิจ ไม่สำเร็จ"));
        })
        .finally(() => {
          dispatch(unsetLoading());
        });
    }
  };

  const handleGetData = useCallback(async () => {
    let query: any = {
      page: page,
      limit: pageLimit,
    };
    if (search) query = { ...query, keyword: search };
    dispatch(setLoading());
    await edpexMissionAPI
      .getEdpexMissionList(query)
      .then((res) => {
        if (res.status < 300) {
          setData(res.data?.data?.items || []);
          setTotalItems(res.data?.data?.meta?.totalItems || 0);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        dispatch(unsetLoading());
      });
  }, [page, pageLimit, search]);

  useEffect(() => {
    handleGetData();
  }, [handleGetData]);

  return (
    <ContainerLayout
      title={t("เพิ่มพันธกิจ")}
      navigateContent={
        <NavigateListCustom
          navigateData={[
            {
              key: "1",
              name: t("ระบบ Edpex"),
              disabled_match: true,
              pathName: routeName.cms.edpexResultDisplay,
            },
            {
              key: "2",
              name: t("พันธกิจ"),
              pathName: routeName.cms.edpexMission,
            },
          ]}
        />
      }
      content={
        <>
          <div className="w-full flex justify-between">
            <span className="flex-1">
              <StateComponents
                otherProps={{ spacing: 2 }}
                typeProps={[
                  {
                    seq: 1,
                    type: "TEXT_FIELD",
                    gridProps: {
                      xs: 12,
                      md: 4,
                    },
                    fieldProps: {
                      startAdornment: <SearchOutlinedIcon />,
                      placeholder: t("ค้นหา ชื่อพันธกิจ, ผู้ที่สร้าง/ปรับปรุง"),
                      onChange: (e) =>
                        debouncedApiCall({
                          searchItem: e.target.value,
                          setItem: setSearch,
                        }),
                    },
                  },
                  {
                    seq: 2,
                    type: "DATE",
                    gridProps: {
                      xs: 12,
                      md: 4,
                    },
                    fieldProps: {
                      onChange: () => {},
                      placeholder: t("จากวันที่"),
                      value: "",
                    },
                  },
                ]}
              />
            </span>
            <span>
              <ButtonPrimary
                mode="add"
                onClick={() => handleShowModal("ADD")}
                buttonName={t("เพิ่มพันธกิจ")}
              />
            </span>
          </div>
          <div className="mt-10">
            <section className="w-full mt-10">
              <TableCustom
                tableMinWidth={1920}
                tableFixedWidth
                customScroll
                page={page}
                pageLimit={pageLimit}
                sortBy={sortBy}
                sortType={sortType}
                headCells={headCells}
                rowCount={totalItems}
                rowsData={data?.map((data: any, i: any) => {
                  return renderData(data, i);
                })}
                onSort={handleRequestSort}
                setPageLimit={(value: number) => setPageLimit(value)}
                setPage={(value: number) => setPage(value)}
              />
            </section>
          </div>

          {showModal && (
            <ModalCustom
              open
              title={
                showModal === "ADD"
                  ? t("เพิ่มพันธกิจ")
                  : showModal === "VIEW"
                  ? t("ข้อมูลพันธกิจ")
                  : ""
              }
              subTitle={t("PLEASE_SELECT_LIST")}
              onClose={handleCloseModal}
              component={
                <div className="w-full">
                  <StateComponents
                    otherProps={{ spacing: 2 }}
                    typeProps={[
                      {
                        seq: 1,
                        gridProps: {
                          xs: 12,
                        },
                        fieldProps: {
                          disabled: showModal === "VIEW",
                          value: formState.edpex_mission_name,
                          heading: t("ชื่อพันธกิจ"),
                          placeholder: t("ชื่อพันธกิจ"),
                          onChange: (e) => {
                            setFormState({
                              ...formState,
                              edpex_mission_name: e.target.value,
                            });
                          },
                        },
                        type: "TEXT_FIELD",
                      },
                      // {
                      //   seq: 2,
                      //   gridProps: {
                      //     xs: 12,
                      //   },
                      //   fieldProps: {
                      //     disabled: true,
                      //     value: formState.edpex_mission_desc,
                      //     heading: t("ชื่อพันธกิจ"),
                      //     placeholder: t("ชื่อพันธกิจ"),
                      //     onChange: (e) => {},
                      //   },
                      //   type: "TEXT_FIELD",
                      // },
                    ]}
                  />

                  <div className="mt-6 w-full flex justify-center gap-4 items-center">
                    <span>
                      <ButtonPrimary
                        mode="del"
                        buttonName={t("BUTTON.CANCEL")}
                        onClick={handleCloseModal}
                      />
                    </span>
                    {showModal !== "VIEW" && (
                      <span>
                        <ButtonPrimary
                          mode="done"
                          buttonName={t("BUTTON.CONFIRM")}
                          disabled={!formState.edpex_mission_name}
                          onClick={handleSubmit}
                        />
                      </span>
                    )}
                  </div>
                </div>
              }
            />
          )}
        </>
      }
    />
  );
};

export default EdpexMission;
